<template>
    <div style="display: inline-block">
        <i class="fa fa-calendar-o"></i> &nbsp; {{ nowDate }} &nbsp; :: &nbsp;
        &nbsp; <i class="fa fa-clock-o"></i> &nbsp; {{ nowTime }}
    </div>
</template>

<script>
    import moment from 'moment';
    export default {
       data: function (){
          return {
             start: Date.now(),
             nowDate: Date.now(),
             nowTime: Date.now()
          }
       },
       created:function(){
          this.calculate();
       },
       methods: {
          calculate: function() {
             var that = this;
             setInterval(function() {
                that.nowDate = moment().format('DD. MM. YYYY');
                that.nowTime = moment().format('H:mm:ss');
             }, 1000);
          }
       }
    }
</script>


// WEBPACK FOOTER //
// clock.vue?263329fa